import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { QuaggaJSResultObject } from "@ericblade/quagga2";
import { BarcodeScannerLivestreamComponent } from "./barcode-scanner-livestream.component";
import "./barcode-scanner.component.scss";

@Component({
    selector: "barcode-scanner",
    template: require('./barcode-scanner.component.html')
})
export class BarcodeScannerComponent implements AfterViewInit {

    @Output() selected = new EventEmitter<string>();
    @Output() onScanned = new EventEmitter<string>();

    // ---

    @ViewChild(BarcodeScannerLivestreamComponent) barcodeScanner: BarcodeScannerLivestreamComponent;

    barcodeValues: string[] = [];

    constructor() {

    }

    ngAfterViewInit() {
        this.barcodeScanner.start();
    }

    onSelected(value: string) {
        console.log(value);
        this.selected.emit(value);
    }

    onValueChanges(result: QuaggaJSResultObject) {
        if (this.barcodeValues.indexOf(result.codeResult.code) >= 0) {
            return;
        }

        this.barcodeValues.push(result.codeResult.code);
        this.onScanned.emit(result.codeResult.code);
    }

    onStarted(started) {
        //console.log(started);
    }

    // ---

}
